import { MembershipsBadgesApiClient } from '@fourthwall/services/dist/MembershipsBadgesApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useEnableVerifiedBadgeMutation = createMutationHook(
  MembershipsBadgesApiClient.enableVerifiedBadge,
  {
    mutationKey: ['enableVerifiedBadge'],
  },
)
